/* eslint-disable no-case-declarations */
import {
  SET_CONTEXT_SUCCESS,
  FETCH_CONTEXTS_SUCCESS,
  FETCHING_CONTEXTS,
  FETCHING_USER,
  FETCH_USER_SUCCESS,
  FETCH_USER_FAIL
} from './ContextsConstants';
import { LOGOUT_SUCCESS } from 'redux/auth/AuthConstants';
import { s1SessionStorage } from 's1-service-ui-components';
import {
  USER_ORG,
  USER_INFO,
  ORG_TREE
} from 'shared/constants/SharedConstants';

let userInfo;
let selectedOrg;
let orgTree;

try {
  userInfo = JSON.parse(sessionStorage.getItem(USER_INFO)) || {};
  orgTree = JSON.parse(sessionStorage.getItem(ORG_TREE)) || [];
  selectedOrg = JSON.parse(sessionStorage.getItem(USER_ORG));
} catch (e) {
  userInfo = {};
  selectedOrg = {
    name: 'ORG-NAME',
    type: 'production',
    taxYear: '2019'
  };
  orgTree = [];
}

const initialStore = {
  fetchingContexts: false,
  fetchingUser: false,
  user: userInfo,
  fetchingClient: false,
  fetchingUserContext: false,
  savingUserContext: false,
  orgTree,
  selectedOrg: selectedOrg || {
    name: 'ORG-NAME',
    type: 'production',
    taxYear: '2019'
  }
};

const getSelectedOrg = (tree, selectedOrgId) => {
  for (let i = 0; i < tree.length; i++) {
    const node = tree[i];
    if (node.id === selectedOrgId) {
      return node;
    } else if (node.nestedContexts) {
      let result = null;
      for (let j = 0; result == null && j < node.nestedContexts.length; j++) {
        result = getSelectedOrg([node.nestedContexts[j]], selectedOrgId);
      }
      if (result) {
        return result;
      }
    }
  }
  return undefined;
};

const ContextsReducer = (state = initialStore, action) => {
  switch (action.type) {
    case FETCH_CONTEXTS_SUCCESS:
      const orgTree = action.contexts;
      const organization = getSelectedOrg(orgTree, action.selectedOrgId);
      s1SessionStorage.setS1Context(organization.id);
      sessionStorage.setItem(USER_ORG, JSON.stringify(organization));
      sessionStorage.setItem(ORG_TREE, JSON.stringify(orgTree));
      return {
        ...state,
        selectedOrg: organization,
        orgTree: orgTree,
        fetchingContexts: false
      };
    case FETCHING_CONTEXTS:
      return { ...state, fetchingContexts: true };
    case FETCHING_USER:
      return { ...state, fetchingUser: true };
    case FETCH_USER_SUCCESS:
      sessionStorage.setItem(USER_INFO, JSON.stringify(action.userInfo));
      return { ...state, fetchingUser: false, user: action.userInfo };
    case FETCH_USER_FAIL:
      return { ...state, fetchingUser: false };
    case SET_CONTEXT_SUCCESS:
      sessionStorage.setItem(USER_ORG, JSON.stringify(action.newOrg));
      return { ...state, selectedOrg: { ...action.newOrg } };
    case LOGOUT_SUCCESS:
      return { ...initialStore };
    default:
      return state;
  }
};

export default ContextsReducer;



// WEBPACK FOOTER //
// ./src/redux/contexts/ContextsReducer.js